import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { createRoot } from 'react-dom/client';
import PageFlyContainer from '../components/page-fly/PageFlyContainer';
import PageFlyNav from './pagefly/pagefly-navigation';
import { useCustomerContext } from '@jbhi-fi/components/src/context/CustomerContextProvider';
import { HeroBannerCarousel } from '@jbhi-fi/components/src/HeroBannerCarousel/HeroBannerCarousel';
import { useContentfulAds } from '@jbhi-fi/components/src/hooks/useContentfulAds';
import { CarouselBannerTransformer } from '@jbhi-fi/components/src/Contentful/transformers/CarouselBannerTransformer';
import { WingsTransformer } from '@jbhi-fi/components/src/Contentful/transformers/WingsTransformer';
import { Wings } from '@jbhi-fi/components/src/Wings/Wings';
import { ContentfulApiClient, ContentfulPreviewThemeApiClient } from '../api/contentful/ContentfulClient';
import { BaseContentProvider } from '../templates/components/stack/components/BaseContentProvider/BaseContentProvider';

const PERKS_IDENTIFIER = '-perks';
const MAX_CAROUSEL_BANNERS = 8;
const handle = window.location.pathname.split('/').pop();
const PageFlyRedirect = () => {
  const { isPerks } = useCustomerContext();
  useEffect(() => {
    if (isPerks && window.perksRedirect) {
      window.location.pathname = window.location.pathname + PERKS_IDENTIFIER;
    } else if (!isPerks && window.location.pathname.endsWith(PERKS_IDENTIFIER)) {
      window.location.pathname = window.location.pathname.replace(PERKS_IDENTIFIER, '');
    }
  }, [isPerks]);
  return null;
};
const contentfulThemeApiClient = new ContentfulPreviewThemeApiClient();
const contentfulClient = new ContentfulApiClient();

const PageFly = () => {
  if (document.getElementById('__pf')) {
    PageFlyNav();
  }
  //PNP-1873-Grab nodes where the attribute 'data-pagefly-sku' exists
  const pageFlyNodes = document.querySelectorAll('[data-pagefly-sku]');
  // PNP-1873-Create css classes using attributes as opposed to css styles because pagefly styles are dynamic.
  if (pageFlyNodes && pageFlyNodes[0]) {
    pageFlyNodes[0].closest('[data-pf-type="Row"]').dataset.pageflyRow = 'true';
    pageFlyNodes[0].closest('[data-pf-type="Column"]').dataset.pageflyColumn = 'true';
  }
  // PNP-1873-Create variable 'node' that passes through PageFlyNodes array and renders using parent container PageFlyContainer.js
  const node = pageFlyNodes[0];

  const PageFlyAds = () => {
    const { banners, isLoading, wings } = useContentfulAds({
      queryOptions: { handle: handle },
      contentfulThemeApiClient,
      contentfulClient,
      isPagefly: true,
    });
    const bannerElement = document.getElementById('pagefly-banner-carousel');
    const wingsElement = document.getElementsByClassName('page-width')[0];
    let wingsPortal = null;

    if (wings && wingsElement) {
      const wingsContainer = document.createElement('div');
      wingsElement.prepend(wingsContainer);
      wingsPortal = createPortal(<Wings {...WingsTransformer.toWingsProps(wings)} />, wingsContainer);
    }
    return (
      <>
        {wingsPortal}
        {banners?.length && bannerElement
          ? createPortal(
              <HeroBannerCarousel
                {...CarouselBannerTransformer.toHeroBannerCarouselProps(banners.slice(0, MAX_CAROUSEL_BANNERS), {
                  variant: 'collection',
                })}
                isLoading={isLoading}
                variant="collection"
              />,
              bannerElement
            )
          : null}
      </>
    );
  };

  const bodyContainer = document.getElementById('page-body-container');
  if (bodyContainer && window.location.pathname.includes('/pages/')) {
    const mountPoint = document.createElement('div');
    bodyContainer.appendChild(mountPoint);
    const root = createRoot(mountPoint);
    root.render(
      <BaseContentProvider shopifyProductActionsProviderProps={{ attachPageType: 'pagefly' }}>
        <PageFlyRedirect />
        <PageFlyAds />
      </BaseContentProvider>
    );
  }
  if (node) {
    const root = createRoot(node);
    root.render(
      <BaseContentProvider shopifyProductActionsProviderProps={{ attachPageType: 'pagefly' }}>
        <PageFlyRedirect />
        <PageFlyContainer skuNodes={Array.from(pageFlyNodes)} />
      </BaseContentProvider>,
      node
    );
  }
};

export default PageFly;
